import { Copy } from '@velocity-exchange/icons';
import { cm } from 'src/utils/classNames';
import { copyToClipboard } from 'src/utils/browser';
import { notify } from '../../utils/notifications';

type CopyButtonProps = {
	copyValue: string;
	toastMessage: string;
	className?: string;
};

const CopyButton = (props: CopyButtonProps) => {
	const handleCopy = () => {
		copyToClipboard(props.copyValue);

		notify({
			type: 'info',
			message: props.toastMessage,
		});
	};

	return (
		<Copy
			className={cm(
				'text-text-secondary hover:cursor-pointer hover:brightness-125 active:opacity-50',
				props.className
			)}
			onClick={handleCopy}
		/>
	);
};

export default CopyButton;
